import { consentCookieHelper } from '@sainsburys-tech/boltui-utils'

const consentCategory = 'marketing'

export const hasOneTrustMarketingConsent = cookies => {
  const { getConsentCookieValue, hasOptanonOptedIn, optanonCookieName } = consentCookieHelper

  const consentCookieValue = getConsentCookieValue(cookies, optanonCookieName)

  if (!consentCookieValue) {
    return false
  }

  return hasOptanonOptedIn(consentCookieValue, consentCategory)
}

const hasTealiumMarketingConsent = cookies => {
  const { categories, getConsentCookieValue, getCategorySection, hasOptedIn } = consentCookieHelper
  const consentCookieValue = getConsentCookieValue(cookies)

  if (!consentCookieValue?.includes('consent:') || !categories?.[consentCategory]) {
    return false
  }

  const categorySection = getCategorySection(consentCookieValue, consentCategory)

  if (!categorySection.length && consentCookieValue.includes('consent:true')) {
    return true
  }

  return hasOptedIn(categorySection[0])
}

export const hasMarketingConsent = () => {
  const cookies = typeof window !== 'undefined' && window.document ? document.cookie : null
  if (!cookies) return false
  const { hasOptanonCookie } = consentCookieHelper
  const useOneTrustCookie = hasOptanonCookie(cookies)
  return useOneTrustCookie ? hasOneTrustMarketingConsent(cookies) : hasTealiumMarketingConsent(cookies)
}
